const NOMINATIM_BASE_URL = 'https://nominatim.openstreetmap.org';
const DEFAULT_LIMIT = 6;

const buildHeaders = () => ({
  Accept: 'application/json',
  'User-Agent': 'Redgaady-Delivery-App/1.0',
});

const normalizePlace = (place, index = 0) => {
  const lat = Number(place.lat);
  const lng = Number(place.lon ?? place.lng);
  const pincode = place.address?.postcode || place.postcode || place.postalCode || '';

  return {
    id: place.place_id || place.osm_id || `${place.display_name}-${index}`,
    name: place.display_name || place.name || 'Selected location',
    lat,
    lng,
    address: place.display_name || place.address || '',
    pincode,
  };
};

export const searchLocations = async (query, limit = DEFAULT_LIMIT) => {
  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return [];
  }

  const searchParams = new URLSearchParams({
    q: trimmedQuery,
    format: 'jsonv2',
    addressdetails: '1',
    limit: String(limit),
    countrycodes: 'in',
  });

  const response = await fetch(`${NOMINATIM_BASE_URL}/search?${searchParams.toString()}`, {
    headers: buildHeaders(),
  });

  if (!response.ok) {
    throw new Error('Unable to search locations right now.');
  }

  const data = await response.json();

  if (!Array.isArray(data)) {
    return [];
  }

  return data
    .map((place, index) => normalizePlace(place, index))
    .filter((place) => Number.isFinite(place.lat) && Number.isFinite(place.lng));
};

export const reverseGeocode = async (lat, lng) => {
  const searchParams = new URLSearchParams({
    lat: String(lat),
    lon: String(lng),
    format: 'jsonv2',
    addressdetails: '1',
  });

  const response = await fetch(`${NOMINATIM_BASE_URL}/reverse?${searchParams.toString()}`, {
    headers: buildHeaders(),
  });

  if (!response.ok) {
    throw new Error('Unable to resolve the selected location.');
  }

  const data = await response.json();
  const normalized = normalizePlace(data);

  if (!Number.isFinite(normalized.lat) || !Number.isFinite(normalized.lng)) {
    return {
      id: `coords-${lat}-${lng}`,
      name: 'Current Location',
      lat,
      lng,
      address: '',
    };
  }

  return normalized;
};
